import React, { useContext, useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { BodyContext } from '~/context/BodyContext.js'
import { useWindowDimensions } from '~/hooks'

export const Navbar = props => {
    const [setting] = useContext(BodyContext);
    const [activeBurgerMenu, set_activeBurgerMenu] = useState(false)
    const base_path = '';
    const location = useLocation()
    const { height: windowHeight, width: windowWidth } = useWindowDimensions();
    const toggleBurgerMenu = (mode) => {
        set_activeBurgerMenu(mode ? mode : !activeBurgerMenu)
    }
    const r_menuLinks = () => {
        return (
            <>
                <div className="ACTION">
                    <a
                        href={`https://hoteltalar.com`}
                        className={`link -icony ${location.pathname === '/' && "-active"}`}>
                        <i className="ri-home-2-fill"></i>
                        <span className="text">صفحه اصلی</span>
                    </a>
                </div>
                <div className="ACTION">
                    <Link
                        onClick={() => toggleBurgerMenu(false)}
                        to={`${base_path}/`}
                        className={`link -icony ${location.pathname === '/' && "-active"}`}>
                        <i className="ri-newspaper-fill"></i>
                        <span className="text">کاتالوگ</span>
                    </Link>
                </div>
            </>
        )
    }
    return (
        <div className="NAVBAR">
            <div className="c-">
                <div className="ACTION">
                    <Link
                        to={`${base_path}/`}
                        className={`brand`}>
                        <img src={require('~/assets/images/brand/Logo-Full.png').default} />
                    </Link>
                </div>
                <div className="BURGER">
                    <Link
                        style={{
                            borderColor: activeBurgerMenu ? '#000' : 'transparent'
                        }}
                        onClick={() => toggleBurgerMenu()}
                        className={`link -icony`}>
                        <i className="ri-menu-3-line"></i>
                    </Link>
                </div>
                <div className="links _onDesktop">
                    {r_menuLinks()}
                </div>
                <div className="links _onPhone"
                    style={{
                        display: activeBurgerMenu ? (windowWidth <= '700' ? 'flex' : 'none') : 'none'
                    }}
                >
                    {r_menuLinks()}
                </div>
            </div>
        </div>
    )
}
